var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocsModeDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0292969 0.676758H13.4118V17.9687H0.0292969V0.676758ZM0.781122 1.42858V17.2169H12.66V1.42858H0.781122Z",
    fill: "#CED3E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7805 4.28553H2.6608V3.5337H10.7805V4.28553Z",
    fill: "#CED3E7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7805 6.08989H2.6608V5.33806H10.7805V6.08989Z",
    fill: "#CED3E7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7805 7.89429H2.6608V7.14247H10.7805V7.89429Z",
    fill: "#CED3E7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7805 10.9016H2.6608V10.1498H10.7805V10.9016Z",
    fill: "#CED3E7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7805 12.7059H2.6608V11.9541H10.7805V12.7059Z",
    fill: "#CED3E7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7805 14.5103H2.6608V13.7585H10.7805V14.5103Z",
    fill: "#CED3E7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9753 6.69137H13.0358V5.93954H19.7271V23.2315H6.3446V17.5928H7.09643V22.4797H18.9753V6.69137Z",
    fill: "#CED3E7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0957 9.54833L13.1862 9.54833V8.7965H17.0957V9.54833Z",
    fill: "#CED3E7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0956 11.3527H13.0358V10.6009L17.0956 10.6009V11.3527Z",
    fill: "#CED3E7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0956 13.1571H13.0358V12.4052L17.0956 12.4052V13.1571Z",
    fill: "#CED3E7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0957 16.1644H13.1862V15.4126H17.0957V16.1644Z",
    fill: "#CED3E7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0957 17.9688H8.97597V17.2169H17.0957V17.9688Z",
    fill: "#CED3E7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0957 19.7731H8.97597V19.0213H17.0957V19.7731Z",
    fill: "#CED3E7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocsModeDark);
export default __webpack_public_path__ + "static/media/docs-mode_dark.acb0c76bba49b90d9cf76aeb76031235.svg";
export { ForwardRef as ReactComponent };